import React, { PureComponent } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Bar, BarChart, Cell, XAxis, YAxis } from "recharts";

import {
  getMetricForColumn,
  MAIN_COLORS,
  TableContentColoredIcon,
  getAllKeys,
  Error,
  renderTrendTable,
} from "components/Utils/Utils";

class SummaryChannelByType extends PureComponent {
  renderTable(data) {
    const { cells, title } = this.props;

    // add unique ids
    data.forEach((d, i) => (d.id = i));

    const columns = this.props.columns || [
      {
        dataField: "title",
        text: "",
        style: { width: "100px", minWidth: "100px" },
        formatter: TableContentColoredIcon,
      },
      {
        dataField: "currentValue",
        text: "Last Week",
        style: { width: "40px", minWidth: "40px" },
        formatter: getMetricForColumn,
      },
      {
        dataField: "pastValue",
        text: "Prior Week",
        style: { width: "40px", minWidth: "40px" },
        formatter: getMetricForColumn,
      },
      {
        dataField: "change",
        text: "%",
        style: { width: "20px", minWidth: "20px" },
        formatter: renderTrendTable,
      },
    ];

    const defaultSorted = [
      {
        dataField: this.props.sortBy || "title",
        order: "desc",
      },
    ];

    let selected_columns = columns;
    if (cells && cells.length) {
      selected_columns = [];
      cells.forEach((cell, i) => {
        selected_columns.push(columns.find((o) => o.dataField === cell));
      });
    }

    const filename = title || "spreadsheet";
    return (
      <ToolkitProvider
        keyField="id"
        data={data}
        columns={selected_columns}
        defaultSorted={defaultSorted}
        striped={false}
        hover={false}
        bordered={false}
        exportCSV={{
          fileName: filename + ".csv",
          exportAll: false,
          onlyExportFiltered: true,
        }}
      >
        {(props) => (
          <BootstrapTable
            {...props.baseProps}
            {...props.csvProps}
            headerClasses={this.props.hideColumns ? "hidden-columns" : ""}
            ref={(el) => (this.childRef = el)}
          />
        )}
      </ToolkitProvider>
    );
  }

  renderBars = (data) => {
    let bars = [];
    const sortedKeys = this.props.elementColors
      ? Object.keys(this.props.elementColors)
      : this.getSortedKeys(data);

    [...new Set(sortedKeys)].forEach((bar, i) => {
      bars.push(
        <Bar
          key={i}
          dataKey={bar}
          stackId="stack"
          fill={
            this.props.elementColors
              ? this.props.elementColors[bar]
              : MAIN_COLORS[i]
          }
          isAnimationActive={false}
        >
          {data.map(
            (entry, index) =>
              entry && (
                <Cell
                  key={`cell-${bar}-${index}`}
                  fillOpacity={index === 1 ? 0.7 : 1}
                ></Cell>
              )
          )}
        </Bar>
      );
    });

    return bars;
  };

  getSortedKeys = (_data) => {
    if (!_data) return [];
    if (!_data[0]) return [];
    const data = _data.filter((d) => d);

    const keys = getAllKeys(data, ["name"]);

    const len = data.length;

    return keys
      .map((key) => ({
        key: key,
        value: data.reduce((accum, curr) => accum + (curr[key] || 0), 0) / len,
      }))
      .sort((a, b) => b.value - a.value)
      .map((d) => d.key);
  };

  render() {
    const { data, graph } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }

    return (
      <div className="row">
        <div className="col-2">
          <BarChart
            height={200}
            width={50}
            data={graph}
            barCategoryGap={1}
            margin={{
              top: 0,
              right: 5,
              left: 5,
              bottom: 0,
            }}
          >
            <XAxis
              dataKey="name"
              tickLine={false}
              axisLine={false}
              interval={0}
            />
            <YAxis hide tickLine={false} axisLine={false} />

            {this.renderBars(graph)}
          </BarChart>
        </div>
        <div className="col-10">{this.renderTable(data)}</div>
      </div>
    );
  }
}

export default SummaryChannelByType;
